import axios from "axios";

export function getStudentReportsByCenterId(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/getstudentreportsbycenterid", config);
}

export function getStudentReportsByPeriodId(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/getstudentreportsbyperiodid", config);
}

export function getStudentReportsByCountries(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/getstudentreportsbycountries", config);
}

export function getLecturerReports(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/lecturerreports", config);
}

export function getCertificatesReports(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/certificates", config);
}
export function getCountryStudentReport(co) {
  //console.log("co", co)

  const data = {
    startDate: co[0],
    endDate: co[1]
  }
  const config = {
    params: data,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Reports/getstudentreportbycountry", config);
}
